import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {formatErrors} from 'actions/errors';

const checkAuthentication = (props) => {
  if (!props.isAuthenticated) {
    props.formatErrors({
      message: 'You need to login to access this page',
      status: 401,
    });
  }
};

export default (Component) => {
  class Authenticate extends React.Component {
    static propTypes = {
      isAuthenticated: PropTypes.bool.isRequired,
      formatErrors: PropTypes.func.isRequired,
    };

    componentDidMount() {
      checkAuthentication(this.props);
    }

    componentDidUpdate() {
      checkAuthentication(this.props);
    }

    render() {
      return <Component {...this.props} />;
    }
  }

  const mapStateToProps = (state) => ({
    isAuthenticated: state.account.get('isAuthenticated'),
  });

  const mapDispatchToState = (dispatch) => ({
    formatErrors: (response, redirectTo) => dispatch(formatErrors(response, redirectTo)),
  });

  return connect(mapStateToProps, mapDispatchToState)(Authenticate);
};
